const PathList = {
  _Login: "/login",
  _Dashboard: "/",
  _User: "/user",
  _Partners: "/partners",
  _Booking: '/booking',
  _Payment: "/payment",
  _Inquiry: "/inquiry",
  _Contact: "/contact",
  _UserDetails: '/user/details',
  _Content: '/content',
  _Review: '/review',
  _FAQs: "/faq",
  _PartnerDetails: '/partner/details',
  _Statistics: "/statistics",
  _NewsLetter: '/newsletter',
  _Disc_Coupon: '/coupons',
};

export default PathList;
